import React, { useEffect, useState } from "react";

/** "Recharge Phone" → "RP", "DTH" → "DT" */
export function serviceInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/[\s/_-]+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

/**
 * Service / category tile — image if available, else short initials.
 * Any image aspect ratio fits cleanly via object-contain.
 */
const ServiceTile = ({
  name,
  iconSrc,
  inactive = false,
  onClick,
  badge,
}) => {
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    setImgFailed(false);
  }, [iconSrc]);

  const showImage = Boolean(iconSrc) && !imgFailed;
  const initials = serviceInitials(name);

  return (
    <button
      type="button"
      disabled={inactive}
      onClick={onClick}
      className={`ds-card ds-service-tile relative flex flex-col items-center justify-center text-center gap-2.5 min-h-[128px] p-3.5
        transition-colors duration-150
        ${inactive ? "opacity-55 cursor-not-allowed" : "cursor-pointer hover:border-[var(--primary-color)]"}
      `}
    >
      <div className="ds-service-icon" aria-hidden={!showImage}>
        {showImage ? (
          <img
            src={iconSrc}
            alt=""
            loading="lazy"
            decoding="async"
            className="ds-service-icon__img"
            onError={() => setImgFailed(true)}
          />
        ) : (
          <span className="ds-service-icon__letter">{initials}</span>
        )}
      </div>
      <p className="text-[12px] font-semibold text-[var(--text-dark)] leading-snug uppercase line-clamp-2 px-0.5">
        {name}
      </p>
      {/* {(badge || inactive) && (
        <span className="ds-badge ds-badge-warning absolute bottom-2 text-[10px]">
          {badge || "Coming Soon"}
        </span>
      )} */}
      {(badge || inactive) && (
  <div className="absolute inset-0 z-10 flex items-center justify-center rounded-[inherit] bg-white/70 backdrop-blur-[1px]">
    <span className="ds-badge ds-badge-warning text-[10px] font-semibold">
      {badge || "Coming Soon"}
    </span>
  </div>
)}
    </button>
  );
};

export default ServiceTile;
